import React from 'react'
import LiveTile from '../common/LiveTile'
import DocumentLink from '../common/DocumentLink'

type RecommendedDocumentProps = {
  name: string
  urlDoc: string
  urlPdf: string
}
type RecommendedDocumentState = null
class RecommendedDocument extends React.Component<
  RecommendedDocumentProps,
  RecommendedDocumentState
> {
  render() {
    const {} = this.props
    return (
      <LiveTile name={this.props.name}>
        <p>{this.props.children}</p>
        <p>
          <DocumentLink
            name={this.props.name}
            urlDoc={this.props.urlDoc}
            urlPdf={this.props.urlPdf}
          />
        </p>
      </LiveTile>
    )
  }
}

export default RecommendedDocument
